import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { extractErrorMessage } from '@brokerportal/common/utils/error.utils';
import { AsyncConfig } from '@brokerportal/modules/quote/shared/models';

@Injectable()
export class ErrorCallbackGeneratorService {
    constructor() {}

    generate(
        callDescription: string,
        targetSnackBar: MatSnackBar,
        callerConfig?: AsyncConfig,
        arrayErrorCallback?: (err: any) => any
    ): (any) => void {
        return error => {
            if (arrayErrorCallback && Array.isArray(error)) {
                this.setLoaded(callerConfig);
                arrayErrorCallback(error);
                return;
            }

            const errorMessage = extractErrorMessage(error, {
                defaultMessage: 'An unexpected error occurred. Please try again.'
            });

            targetSnackBar.open(`Error ${callDescription}: ${errorMessage}`, 'Dismiss', { duration: 8000 });
            this.setLoaded(callerConfig);
        };
    }

    setLoaded(callerConfig) {
        if (callerConfig) {
            callerConfig.isLoading = false;
        }
    }
}
